module.exports = __webpack_public_path__ + "static/media/sim-ling-ling.274d97f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Unlock/sounds/sim-ling-ling.mp3
// module id = 474
// module chunks = 0